import {
  Alignment,
  Border,
  BorderRadius,
  BorderStyle,
  Common,
  DeepBlue,
  Displaying,
  Spacing,
} from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";

const MOBILE_APP_BANNER_HEIGHT = 56;
export const MOBILE_APP_BANNER_ICON_SIZE = 40;

export const MobileAppBannerWrapperElement = styled(Box)({
  height: MOBILE_APP_BANNER_HEIGHT,
  display: Displaying.flex,
  justifyContent: Alignment.spaceBetween,
  alignItems: Alignment.center,
  backgroundColor: DeepBlue.light,
  padding: `${Spacing["500"]} ${Spacing["750"]} ${Spacing["500"]} ${Spacing["250"]}`,
  borderBottom: `1px ${BorderStyle.solid} ${Border.main}`,
});

export const MobileAppBannerInner = styled("div")({
  display: "inherit",
  alignItems: "inherit",
});

export const MobileAppBannerIconWrapper = styled("div")({
  display: Displaying.flex,
  backgroundColor: Common.white.main,
  borderRadius: BorderRadius.paper,
  marginRight: Spacing["750"],
  marginLeft: Spacing["250"],
});
